import { render, staticRenderFns } from "./MailServiceSettings.vue?vue&type=template&id=384c9142&scoped=true"
import script from "./MailServiceSettings.vue?vue&type=script&lang=js"
export * from "./MailServiceSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384c9142",
  null
  
)

export default component.exports